import { Theme } from "@shared/lib/constants/themes";
import { readonly } from "vue";

export const topPlayerMap = readonly(new Map<keyof typeof Theme, {
  name: string,
  email: string,
  location: string,
  height: number,
  weight: number,
  birthdate: string,
  jersey_number: number,
}>([
  [
    "AtlantaHawks",
    {
      name: "Jalen Johnson",
      email: "jalen@hawks.com",
      location: "Atlanta, GA",
      height: 80,
      weight: 220,
      birthdate: "2001-12-18",
      jersey_number: 1,
    },
  ],
  [
    "BostonCeltics",
    {
      name: "Jayson Tatum",
      email: "tatum@celtics.com",
      location: "Boston, MA",
      height: 80,
      weight: 210,
      birthdate: "1998-03-03",
      jersey_number: 0,
    },
  ],
  [
    "BrooklynNets",
    {
      name: "Michael Porter Jr.",
      email: "mpj@nets.com",
      location: "Brooklyn, NY",
      height: 82,
      weight: 218,
      birthdate: "1998-06-29",
      jersey_number: 13,
    },
  ],
  [
    "CharlotteHornets",
    {
      name: "Brandon Miller",
      email: "miller@hornets.com",
      location: "Charlotte, NC",
      height: 79,
      weight: 200,
      birthdate: "2002-11-22",
      jersey_number: 24,
    },
  ],
  [
    "ChicagoBulls",
    {
      name: "Josh Giddey",
      email: "giddey@bulls.com",
      location: "Chicago, IL",
      height: 80,
      weight: 216,
      birthdate: "2002-10-10",
      jersey_number: 3,
    },
  ],
  [
    "ClevelandCavaliers",
    {
      name: "Donovan Mitchell",
      email: "spida@cavaliers.com",
      location: "Cleveland, OH",
      height: 73,
      weight: 215,
      birthdate: "1996-09-07",
      jersey_number: 45,
    },
  ],
  [
    "DallasMavericks",
    {
      name: "Cooper Flagg",
      email: "cooper@mavs.com",
      location: "Dallas, TX",
      height: 81,
      weight: 205,
      birthdate: "2006-12-21",
      jersey_number: 32,
    },
  ],
  [
    "DenverNuggets",
    {
      name: "Nikola Jokić",
      email: "joker@nuggets.com",
      location: "Sombor, Serbia",
      height: 83,
      weight: 284,
      birthdate: "1995-02-19",
      jersey_number: 15,
    },
  ],
  [
    "DetroitPistons",
    {
      name: "Cade Cunningham",
      email: "cade@pistons.com",
      location: "Detroit, MI",
      height: 78,
      weight: 220,
      birthdate: "2001-09-25",
      jersey_number: 2,
    },
  ],
  [
    "GoldenStateWarriors",
    {
      name: "Stephen Curry",
      email: "steph@warriors.com",
      location: "San Francisco, CA",
      height: 74,
      weight: 185,
      birthdate: "1988-03-14",
      jersey_number: 30,
    },
  ],
  [
    "HoustonRockets",
    {
      name: "Kevin Durant",
      email: "kd@rockets.com",
      location: "Houston, TX",
      height: 83,
      weight: 240,
      birthdate: "1988-09-29",
      jersey_number: 7,
    },
  ],
  [
    "IndianaPacers",
    {
      name: "Tyrese Haliburton",
      email: "hali@pacers.com",
      location: "Indianapolis, IN",
      height: 77,
      weight: 185,
      birthdate: "2000-02-29",
      jersey_number: 0,
    },
  ],
  [
    "LosAngelesClippers",
    {
      name: "Darius Garland",
      email: "darius@clippers.com",
      location: "Los Angeles, CA",
      height: 73,
      weight: 192,
      birthdate: "2000-01-26",
      jersey_number: 10,
    },
  ],
  [
    "LosAngelesLakers",
    {
      name: "Luka Dončić",
      email: "luka@lakers.com",
      location: "Ljubljana, Slovenia",
      height: 79,
      weight: 230,
      birthdate: "1999-02-28",
      jersey_number: 77,
    },
  ],
  [
    "MemphisGrizzlies",
    {
      name: "Cameron Boozer",
      email: "boozer@grizzlies.com",
      location: "Memphis, TN",
      height: 81,
      weight: 253,
      birthdate: "2007-07-18",
      jersey_number: 27,
    },
  ],
  [
    "MiamiHeat",
    {
      name: "Giannis Antetokounmpo",
      email: "giannis@heat.com",
      location: "Athens, Greece",
      height: 83,
      weight: 243,
      birthdate: "1994-12-06",
      jersey_number: 34,
    },
  ],
  [
    "MilwaukeeBucks",
    {
      name: "Tyler Herro",
      email: "herro@bucks.com",
      location: "Milwaukee, WI",
      height: 77,
      weight: 195,
      birthdate: "2000-01-20",
      jersey_number: 14,
    },
  ],
  [
    "MinnesotaTimberwolves",
    {
      name: "Anthony Edwards",
      email: "ant@twolves.com",
      location: "Minneapolis, MN",
      height: 76,
      weight: 225,
      birthdate: "2001-08-05",
      jersey_number: 5,
    },
  ],
  [
    "NewOrleansPelicans",
    {
      name: "Zion Williamson",
      email: "zion@pelicans.com",
      location: "New Orleans, LA",
      height: 78,
      weight: 284,
      birthdate: "2000-07-06",
      jersey_number: 1,
    },
  ],
  [
    "NewYorkKnicks",
    {
      name: "Jalen Brunson",
      email: "jalen@knicks.com",
      location: "New York, NY",
      height: 74,
      weight: 190,
      birthdate: "1996-08-31",
      jersey_number: 11,
    },
  ],
  [
    "OklahomaCityThunder",
    {
      name: "Shai Gilgeous-Alexander",
      email: "sga@thunder.com",
      location: "Oklahoma City, OK",
      height: 78,
      weight: 200,
      birthdate: "1998-07-12",
      jersey_number: 2,
    },
  ],
  [
    "OrlandoMagic",
    {
      name: "Paolo Banchero",
      email: "paolo@magic.com",
      location: "Orlando, FL",
      height: 82,
      weight: 250,
      birthdate: "2002-11-12",
      jersey_number: 5,
    },
  ],
  [
    "Philadelphia76ers",
    {
      name: "Tyrese Maxey",
      email: "maxey@76ers.com",
      location: "Philadelphia, PA",
      height: 74,
      weight: 200,
      birthdate: "2000-11-04",
      jersey_number: 0,
    },
  ],
  [
    "PhoenixSuns",
    {
      name: "Devin Booker",
      email: "book@suns.com",
      location: "Phoenix, AZ",
      height: 77,
      weight: 206,
      birthdate: "1996-10-30",
      jersey_number: 1,
    },
  ],
  [
    "PortlandTrailBlazers",
    {
      name: "Ja Morant",
      email: "ja@blazers.com",
      location: "Portland, OR",
      height: 74,
      weight: 174,
      birthdate: "1999-08-10",
      jersey_number: 12,
    },
  ],
  [
    "SacramentoKings",
    {
      name: "DeMar DeRozan",
      email: "derozan@kings.com",
      location: "Sacramento, CA",
      height: 78,
      weight: 220,
      birthdate: "1989-08-07",
      jersey_number: 10,
    },
  ],
  [
    "SanAntonioSpurs",
    {
      name: "Victor Wembanyama",
      email: "wemby@spurs.com",
      location: "Le Chesnay, France",
      height: 88,
      weight: 210,
      birthdate: "2004-01-04",
      jersey_number: 1,
    },
  ],
  [
    "TorontoRaptors",
    {
      name: "Kawhi Leonard",
      email: "kawhi@raptors.com",
      location: "Toronto, Canada",
      height: 79,
      weight: 225,
      birthdate: "1991-06-29",
      jersey_number: 2,
    },
  ],
  [
    "UtahJazz",
    {
      name: "Lauri Markkanen",
      email: "lauri@jazz.com",
      location: "Salt Lake City, UT",
      height: 84,
      weight: 240,
      birthdate: "1997-05-22",
      jersey_number: 23,
    },
  ],
  [
    "WashingtonWizards",
    {
      name: "Trae Young",
      email: "trae@wizards.com",
      location: "Washington, DC",
      height: 73,
      weight: 164,
      birthdate: "1998-09-19",
      jersey_number: 11,
    },
  ],
  [
    "AtlantaDream",
    {
      name: "Angel Reese",
      email: "angel@dream.com",
      location: "Atlanta, GA",
      height: 76,
      weight: 165,
      birthdate: "2002-05-06",
      jersey_number: 5,
    },
  ],
  [
    "ChicagoSky",
    {
      name: "Kamilla Cardoso",
      email: "kamilla@sky.com",
      location: "Chicago, IL",
      height: 79,
      weight: 170,
      birthdate: "2001-06-23",
      jersey_number: 10,
    },
  ],
  [
    "ConnecticutSun",
    {
      name: "Brittney Griner",
      email: "brittney@sun.com",
      location: "Uncasville, CT",
      height: 81,
      weight: 205,
      birthdate: "1990-10-18",
      jersey_number: 42,
    },
  ],
  [
    "DallasWings",
    {
      name: "Paige Bueckers",
      email: "paige@wings.com",
      location: "Arlington, TX",
      height: 72,
      weight: 154,
      birthdate: "2001-10-20",
      jersey_number: 5,
    },
  ],
  [
    "IndianaFever",
    {
      name: "Caitlin Clark",
      email: "caitlin@fever.com",
      location: "Indianapolis, IN",
      height: 72,
      weight: 152,
      birthdate: "2002-01-22",
      jersey_number: 22,
    },
  ],
  [
    "LasVegasAces",
    {
      name: "A'ja Wilson",
      email: "aja@aces.com",
      location: "Las Vegas, NV",
      height: 76,
      weight: 195,
      birthdate: "1996-08-08",
      jersey_number: 22,
    },
  ],
  [
    "LosAngelesSparks",
    {
      name: "Kelsey Plum",
      email: "kelsey@sparks.com",
      location: "Los Angeles, CA",
      height: 68,
      weight: 145,
      birthdate: "1994-08-24",
      jersey_number: 10,
    },
  ],
  [
    "MinnesotaLynx",
    {
      name: "Napheesa Collier",
      email: "napheesa@lynx.com",
      location: "Minneapolis, MN",
      height: 73,
      weight: 175,
      birthdate: "1996-09-23",
      jersey_number: 24,
    },
  ],
  [
    "NewYorkLiberty",
    {
      name: "Breanna Stewart",
      email: "breanna@liberty.com",
      location: "Brooklyn, NY",
      height: 76,
      weight: 170,
      birthdate: "1994-08-27",
      jersey_number: 30,
    },
  ],
  [
    "PhoenixMercury",
    {
      name: "Alyssa Thomas",
      email: "alyssa@mercury.com",
      location: "Phoenix, AZ",
      height: 74,
      weight: 203,
      birthdate: "1992-04-12",
      jersey_number: 25,
    },
  ],
  [
    "SeattleStorm",
    {
      name: "Dominique Malonga",
      email: "dominique@storm.com",
      location: "Yaoundé, Cameroon",
      height: 78,
      weight: 180,
      birthdate: "2005-11-16",
      jersey_number: 14,
    },
  ],
  [
    "WashingtonMystics",
    {
      name: "Sonia Citron",
      email: "sonia@mystics.com",
      location: "Washington, DC",
      height: 73,
      weight: 175,
      birthdate: "2003-10-22",
      jersey_number: 22,
    },
  ],
  [
    "GoldenStateValkyries",
    {
      name: "Veronica Burton",
      email: "veronica@valkyries.com",
      location: "San Francisco, CA",
      height: 69,
      weight: 155,
      birthdate: "2000-07-12",
      jersey_number: 22,
    },
  ],
]));
